export default "__VITE_ASSET__BtIWzKzm__"